module.exports = "https://static.wmbcdn.com/uniweb/images/659b5a97b82d48d71365dd0104d99227.svg";